import React from "react";
import { ArrowBack, Article, Category, LocalShipping, Person } from "@mui/icons-material";
import { Button, Paper, Skeleton, Typography } from "@mui/material";
import { t } from "i18next";

interface IBtmReturnRequestLoaderProps {
    onClose?: () => void;
}

export const BtmReturnRequestLoader = (props: IBtmReturnRequestLoaderProps) => {
    return <div className={"btm-request-details__container"}>
        <Paper elevation={0} className={"btm-request-details__navigation"}>
            {props.onClose ?
                <Button onClick={props.onClose} sx={{ gap: "15px" }}>
                    <ArrowBack />
                    <Typography>{t("components.blueBrandReturns.page.details.back")}</Typography>
                </Button> : <div />}
            <Skeleton width={90} />
        </Paper>
        <div className={"btm-request-details__content"}>
            <div className={"btm-request-details__column"}>
                <Paper elevation={0} className={"btm-request-details__section btm-request-details__section--main"}>
                    <Typography variant={"h4"} color={"textPrimary"} className={"btm-request-details__title"}>
                        <Article color={"primary"} fontSize={"large"} />
                        <span>{t("components.blueBrandReturns.page.details.title.main", { declarationId: "" })}</span>
                        <Typography fontSize={"large"}><Skeleton width={120} /></Typography>
                    </Typography>
                    <div className={"btm-request-details__table"}>
                        <div className={"btm-request-details__table-row"}>
                            <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.orderId")}</Typography>
                            <Typography fontSize={"large"}><Skeleton width={120} /></Typography>
                        </div>
                        <div className={"btm-request-details__table-row"}>
                            <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.createdAt")}</Typography>
                            <Typography fontSize={"large"}><Skeleton width={160} /></Typography>
                        </div>
                    </div>
                </Paper>
                <Paper elevation={0} className={"btm-request-details__section"}>
                    <Typography variant={"h4"} color={"textPrimary"}>
                        <LocalShipping color={"primary"} fontSize={"medium"} />
                        <span>{t("components.blueBrandReturns.page.details.title.trackingDetails")}</span>
                    </Typography>
                    <div className={"btm-request-details__table"}>
                        <div className={"btm-request-details__table-row"}>
                            <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.carrier")}</Typography>
                            <Typography fontSize={"large"}><Skeleton width={180} /></Typography>
                        </div>
                        <div className={"btm-request-details__table-row"}>
                            <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.trackingAndLabel")}</Typography>
                            <Typography fontSize={"large"}><Skeleton width={200} /></Typography>
                        </div>
                        <div className={"btm-request-details__table-row"}>
                            <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.appointment")}</Typography>
                            <Typography fontSize={"large"}><Skeleton width={200} /></Typography>
                        </div>
                    </div>
                </Paper>
                <div className={"btm-request-details__content"}>
                    <Paper elevation={0} className={"btm-request-details__section"}>
                        <Typography variant={"h4"} color={"textPrimary"}>
                            <Person color={"primary"} fontSize={"medium"} />
                            <span>{t("components.blueBrandReturns.page.details.title.customerDetails")}</span>
                        </Typography>
                        <div className={"btm-request-details__table"}>
                            <div className={"btm-request-details__table-row"}>
                                <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.customerName")}</Typography>
                                <Typography fontSize={"large"}><Skeleton width={220} /></Typography>
                            </div>
                            <div className={"btm-request-details__table-row"}>
                                <Typography color={"textSecondary"}>{t("components.blueBrandReturns.page.details.column.contact")}</Typography>
                                <Typography fontSize={"large"}><Skeleton width={160} /></Typography>
                            </div>
                        </div>
                    </Paper>
                    <Paper elevation={0} className={"btm-request-details__section"}>
                        <Typography variant={"h4"} color={"textPrimary"}>
                            <Category color={"primary"} fontSize={"medium"} />
                            <span>{t("components.blueBrandReturns.page.details.title.productDetails")}</span>
                        </Typography>
                        <div className={"btm-request-product__list"}>
                            <div className={"btm-request-product__line"}>
                                <div className={"btm-request-product__column"}>
                                    <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.products.name")}
                                    </Typography>
                                    <Skeleton width={180} />
                                </div>
                                <div className={"btm-request-product__column"}>
                                    <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.products.quantity")}
                                    </Typography>
                                    <Skeleton width={60} />
                                </div>
                            </div>
                            <div className={"btm-request-product__line"}>
                                <div className={"btm-request-product__column"}>
                                    <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.products.reason")}
                                    </Typography>
                                </div>
                                <div className={"btm-request-product__column"}>
                                    <Skeleton width={"100%"} />
                                </div>
                            </div>
                        </div>
                        <div className={"btm-request-product__list"}>
                            <div className={"btm-request-product__line"}>
                                <div className={"btm-request-product__column"}>
                                    <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.products.name")}
                                    </Typography>
                                    <Skeleton width={180} />
                                </div>
                                <div className={"btm-request-product__column"}>
                                    <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.products.quantity")}
                                    </Typography>
                                    <Skeleton width={60} />
                                </div>
                            </div>
                            <div className={"btm-request-product__line"}>
                                <div className={"btm-request-product__column"}>
                                    <Typography variant={"h5"} className={"btm-request-product__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.products.reason")}
                                    </Typography>
                                </div>
                                <div className={"btm-request-product__column"}>
                                    <Skeleton width={"100%"} />
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>
            </div>
            <div className={"btm-request-details__column btm-request-details__column--right"}>
                <Paper elevation={0} className={"btm-request-details__section"}>
                    <Typography variant={"h4"} color={"textPrimary"}>
                        {t("components.blueBrandReturns.page.details.title.logisticsSetup")}
                    </Typography>
                    <div className={"btm-request-details__wrapper"}>
                        <div className={"btm-request-form"}>
                            <div className={"btm-request-form__row"}>
                                <div>
                                    <Typography variant={"h5"} className={"btm-request-form__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.details.form.carrier.label")}
                                    </Typography>
                                    <Skeleton width={"100%"} height={56} sx={{ transform: "unset" }} />
                                </div>
                            </div>
                            <div className={"btm-request-form__row--multi"}>
                                <div>
                                    <Typography variant={"h5"} className={"btm-request-form__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.details.form.pickupDate.label")}
                                    </Typography>
                                    <Skeleton width={"100%"} height={56} sx={{ transform: "unset" }} />
                                </div>
                                <div>
                                    <Typography variant={"h5"} className={"btm-request-form__label"} color={"textSecondary"}>
                                        {t("components.blueBrandReturns.page.details.form.serviceWindow.label")}
                                    </Typography>
                                    <Skeleton width={"100%"} height={56} sx={{ transform: "unset" }} />
                                </div>
                            </div>
                            <div className={"btm-request-form__row--with-border"}>
                                <Skeleton width={"100%"} height={56} sx={{ transform: "unset" }} />
                            </div>
                            <div className={"btm-request-form__row"}>
                                <Skeleton width={"100%"} height={56} sx={{ transform: "unset" }} />
                            </div>
                            <div className={"btm-request-form__row"}>
                                <Button disabled variant={"contained"} color={"secondary"} size={"large"}>
                                    {t("components.blueBrandReturns.page.details.form.submit")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
        </div>
    </div>;
};
